<template>
  <div>
    <div
      v-for="rfi in rfis"
      :key="rfi.COL_ID"
      class="border-b border-gray-200 p-4"
    >
      <div class="flex justify-between items-start">
        <div>
          <p class="text-sm font-medium text-brand-700">
            {{ rfi.COL_SUBJECT }}
          </p>
          <p class="text-xs text-gray-500 mt-1">ID: {{ rfi.COL_ID }}</p>
        </div>
        <span
          class="px-2 py-1 text-xs rounded-full"
          :class="priorityClasses(rfi.COL_PRIORITY)"
        >
          {{ rfi.COL_PRIORITY }}
        </span>
      </div>
      <div class="mt-2">
        <p class="text-sm text-gray-700 line-clamp-2">
          {{ rfi.COL_QUESTION_REQUEST }}
        </p>
      </div>
      <div class="mt-3 flex justify-between items-center">
        <div>
          <p class="text-xs text-gray-500">
            Requested by: {{ rfi.COL_REQUESTOR_NAME }}
          </p>
          <p class="text-xs text-gray-500">
            Date: {{ formatDate(rfi.COL_DATE_INITIATED) }}
          </p>
        </div>
        <button
          @click="$emit('toggle-details', rfi.COL_ID)"
          class="px-2 py-1 rounded-md bg-brand-50 text-brand-700 text-sm font-medium hover:bg-brand-100 hover:text-brand-800 transition-colors duration-200"
        >
          {{ expandedRfis.includes(rfi.COL_ID) ? "Hide" : "View" }} Details
        </button>
      </div>

      <!-- Expanded details -->
      <div
        v-if="expandedRfis.includes(rfi.COL_ID)"
        class="mt-4 pt-4 border-t border-gray-200"
      >
        <div class="space-y-3">
          <div>
            <p class="text-xs font-medium text-gray-500">Project</p>
            <p class="text-sm text-gray-900">
              {{ rfi.COL_PROJECT || "N/A" }}
            </p>
          </div>
          <div>
            <p class="text-xs font-medium text-gray-500">Discipline</p>
            <p class="text-sm text-gray-900">
              {{ rfi.COL_DISCIPLINE || "N/A" }}
            </p>
          </div>
          <div>
            <p class="text-xs font-medium text-gray-500">Location</p>
            <p class="text-sm text-gray-900">
              {{ rfi.COL_LOCATION || "N/A" }}
            </p>
          </div>
          <div>
            <p class="text-xs font-medium text-gray-500">Possible Impact</p>
            <p class="text-sm text-gray-900">
              {{ rfi.COL_POSSIBLE_IMPACT || "N/A" }}
            </p>
          </div>
          <div>
            <p class="text-xs font-medium text-gray-500">Manager</p>
            <p class="text-sm text-gray-900">
              {{ rfi.COL_MANAGERS_NAME || "N/A" }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rfis: Array,
    expandedRfis: Array
  },
  setup () {
    const formatDate = (dateString) => {
      if (!dateString) return "N/A"
      const options = { year: 'numeric', month: 'short', day: 'numeric' }
      return new Date(dateString).toLocaleDateString(undefined, options)
    }
    const priorityClasses = (priority) => {
      const priorityMap = {
        High: 'bg-red-100 text-red-800',
        Medium: 'bg-yellow-100 text-yellow-800',
        Low: 'bg-green-100 text-green-800'
      }
      return priorityMap[priority] || 'bg-gray-100 text-gray-800'
    }

    return {
        formatDate,
        priorityClasses
    }
  
  }

}
</script>